
import React from 'react';

export const Copyright: React.FC = () => {
  return (
    <div className="text-blue-200 text-xs md:text-sm">
      <p>
        &copy; {new Date().getFullYear()} Hội Cựu học sinh Trường THPT Chuyên Lê Hồng Phong
      </p>
      <p className="mt-1">
        Được hỗ trợ kỹ thuật bởi <a href="https://www.lindigi.com" target="_blank" rel="noopener noreferrer" className="underline hover:text-white transition-colors">LinDiGi</a>
      </p>
    </div>
  );
};
